import { Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { tasksHasFiles } from 'business/shift-report/report/pages/ReportView/services';
import {
  ShowMoreOnMobileState,
  ShowMoreOnMobileStateKeys,
  SHOW_MORE_ON_MOBILE_STATE_KEYS,
} from 'business/shift-report/report/pages/ReportView/types';
import { GetShiftReportPdfMetadataQuery } from 'generated/graphql';
import { useMediaType } from 'technical/media/hooks';
import { ShowMoreToggle } from 'ui/show-more-button';
import { ShowMoreContainer } from 'ui/show-more-button/show-more-container';

import DisplayTasksFiles from './displayTasksFiles';

type TasksFilesContainerProps = {
  tasks: NonNullable<GetShiftReportPdfMetadataQuery['shiftReport']>['tasks'];
  showMore: ShowMoreOnMobileState;
  toggleShowMore: (key: ShowMoreOnMobileStateKeys) => () => void;
};

export const TasksFilesContainer = ({
  tasks,
  showMore,
  toggleShowMore,
}: TasksFilesContainerProps) => {
  const { isMobile } = useMediaType();
  const { t } = useTranslation();

  if (!tasksHasFiles(tasks)) {
    return null;
  }

  return (
    <Flex vertical className="bloc" key="additional-files">
      <h1>{t('pages.print.additionnalImages')}</h1>
      <ShowMoreContainer enableToggle={isMobile} toggleState={showMore.files}>
        <DisplayTasksFiles tasks={tasks} />
      </ShowMoreContainer>
      <ShowMoreToggle
        enableToggle={isMobile}
        toggleState={showMore.files}
        toggleFunc={toggleShowMore(SHOW_MORE_ON_MOBILE_STATE_KEYS.FILES)}
      />
    </Flex>
  );
};
